var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176375",
    "data-name": "Group 176375",
    transform: "translate(-161 -3114)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    transform: "translate(161 3114)",
    fill: "#0154ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "code",
    transform: "translate(174.965 3127.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175957",
    "data-name": "Group 175957",
    transform: "translate(0.555 0.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38344",
    "data-name": "Path 38344",
    d: "M334.352,280.3a3.729,3.729,0,0,1-2.97-1.458l-4.36-5.639a1.578,1.578,0,0,0-1.475-.595l-6.619.971a3.754,3.754,0,0,1-4.243-4.355l1.136-6.552a1.566,1.566,0,0,0-.618-1.538l-5.559-4.092a3.753,3.753,0,0,1-.046-6.011l5.51-4.188a1.576,1.576,0,0,0,.606-1.483l-1-6.849a3.753,3.753,0,0,1,4.107-4.278l7.1.748a1.57,1.57,0,0,0,1.391-.578l4.122-5.111a3.753,3.753,0,0,1,5.843,0L341.4,234.4a1.569,1.569,0,0,0,1.391.578l7.1-.748A3.753,3.753,0,0,1,354,238.507l-1,6.849a1.576,1.576,0,0,0,.606,1.483l5.51,4.188a3.753,3.753,0,0,1-.046,6.011L353.5,261.13a1.567,1.567,0,0,0-.618,1.538l1.136,6.552a3.754,3.754,0,0,1-4.243,4.355l-6.619-.971a1.576,1.576,0,0,0-1.475.595l-4.36,5.639A3.728,3.728,0,0,1,334.352,280.3Zm-8.578-9.887a3.759,3.759,0,0,1,2.971,1.457l4.36,5.639a1.575,1.575,0,0,0,2.493,0l4.361-5.639a3.759,3.759,0,0,1,3.514-1.418l6.619.971a1.575,1.575,0,0,0,1.781-1.828l-1.136-6.552a3.733,3.733,0,0,1,1.473-3.664l5.559-4.092a1.575,1.575,0,0,0,.019-2.523l-5.51-4.187a3.754,3.754,0,0,1-1.443-3.533l1-6.849a1.575,1.575,0,0,0-1.724-1.8l-7.1.748a3.741,3.741,0,0,1-3.315-1.376l-4.122-5.111a1.576,1.576,0,0,0-2.453,0L329,235.767a3.742,3.742,0,0,1-3.315,1.376l-7.1-.748a1.575,1.575,0,0,0-1.724,1.8l1,6.849a3.754,3.754,0,0,1-1.443,3.533l-5.51,4.187a1.575,1.575,0,0,0,.019,2.523l5.559,4.092a3.733,3.733,0,0,1,1.473,3.664l-1.136,6.552a1.576,1.576,0,0,0,1.781,1.828l6.619-.971A3.75,3.75,0,0,1,325.774,270.408Z",
    transform: "translate(-308.114 -227.891)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175964",
    "data-name": "Group 175964",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175960",
    "data-name": "Group 175960",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175958",
    "data-name": "Group 175958",
    transform: "translate(14.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38345",
    "data-name": "Path 38345",
    d: "M415.788,228a1.089,1.089,0,0,1-.985-.623l-1.416-2.99a1.089,1.089,0,1,1,1.969-.932l1.416,2.99a1.09,1.09,0,0,1-.983,1.556Z",
    transform: "translate(-413.281 -222.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175959",
    "data-name": "Group 175959",
    transform: "translate(0 14.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38346",
    "data-name": "Path 38346",
    d: "M308.064,335.839a1.084,1.084,0,0,1-.5-.121l-2.941-1.514a1.089,1.089,0,1,1,1-1.937l2.941,1.514a1.089,1.089,0,0,1-.5,2.058Z",
    transform: "translate(-304.034 -332.146)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175963",
    "data-name": "Group 175963",
    transform: "translate(0 35.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175961",
    "data-name": "Group 175961",
    transform: "translate(14.873 13.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38347",
    "data-name": "Path 38347",
    d: "M414.37,584.37a1.09,1.09,0,0,1-.984-1.555l1.416-2.99a1.089,1.089,0,1,1,1.969.932l-1.416,2.99A1.089,1.089,0,0,1,414.37,584.37Z",
    transform: "translate(-413.281 -579.202)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175962",
    "data-name": "Group 175962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38348",
    "data-name": "Path 38348",
    d: "M305.125,484.422a1.089,1.089,0,0,1-.5-2.058l2.941-1.514a1.089,1.089,0,0,1,1,1.937l-2.941,1.514A1.086,1.086,0,0,1,305.125,484.422Z",
    transform: "translate(-304.034 -480.729)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175971",
    "data-name": "Group 175971",
    transform: "translate(34.89 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175967",
    "data-name": "Group 175967",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175965",
    "data-name": "Group 175965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349",
    "data-name": "Path 38349",
    d: "M561.4,228a1.09,1.09,0,0,1-.984-1.556l1.416-2.99a1.089,1.089,0,1,1,1.969.932l-1.416,2.99A1.089,1.089,0,0,1,561.4,228Z",
    transform: "translate(-560.314 -222.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175966",
    "data-name": "Group 175966",
    transform: "translate(13.348 14.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38350",
    "data-name": "Path 38350",
    d: "M659.45,335.839a1.089,1.089,0,0,1-.5-2.058l2.941-1.514a1.089,1.089,0,1,1,1,1.937l-2.941,1.514A1.085,1.085,0,0,1,659.45,335.839Z",
    transform: "translate(-658.36 -332.146)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175970",
    "data-name": "Group 175970",
    transform: "translate(0 35.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175968",
    "data-name": "Group 175968",
    transform: "translate(0 13.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38351",
    "data-name": "Path 38351",
    d: "M562.82,584.37a1.089,1.089,0,0,1-.985-.623l-1.416-2.99a1.089,1.089,0,0,1,1.969-.932l1.416,2.99a1.09,1.09,0,0,1-.984,1.555Z",
    transform: "translate(-560.314 -579.201)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175969",
    "data-name": "Group 175969",
    transform: "translate(13.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38352",
    "data-name": "Path 38352",
    d: "M662.389,484.422a1.084,1.084,0,0,1-.5-.121l-2.941-1.514a1.089,1.089,0,0,1,1-1.937l2.941,1.514a1.089,1.089,0,0,1-.5,2.058Z",
    transform: "translate(-658.36 -480.729)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175975",
    "data-name": "Group 175975",
    transform: "translate(13.293 13.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175972",
    "data-name": "Group 175972",
    transform: "translate(4.237 0.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38353",
    "data-name": "Path 38353",
    d: "M433.884,349.325a1.089,1.089,0,0,1-.846-1.774l17-21.015a1.089,1.089,0,0,1,1.694,1.37l-17,21.015A1.087,1.087,0,0,1,433.884,349.325Z",
    transform: "translate(-432.795 -326.132)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175973",
    "data-name": "Group 175973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38354",
    "data-name": "Path 38354",
    d: "M406.92,335.927a5.248,5.248,0,1,1,5.223-5.8h0a5.251,5.251,0,0,1-5.223,5.8Zm.01-8.318a3.1,3.1,0,0,0-.328.017,3.07,3.07,0,1,0,3.375,2.73h0a3.07,3.07,0,0,0-3.047-2.747Z",
    transform: "translate(-401.675 -325.43)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175974",
    "data-name": "Group 175974",
    transform: "translate(16.503 14.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38355",
    "data-name": "Path 38355",
    d: "M528.131,442.419a5.249,5.249,0,1,1,5.229-5.8h0a5.248,5.248,0,0,1-4.668,5.77A5.37,5.37,0,0,1,528.131,442.419Zm.016-8.319a3.129,3.129,0,0,0-.328.017,3.07,3.07,0,1,0,3.375,2.73h0a3.07,3.07,0,0,0-3.047-2.748Z",
    transform: "translate(-522.892 -431.922)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/discount-icon.69922d76e227d439ac058928d2bb1925.svg";
export { ForwardRef as ReactComponent };